<template>
  <div>
    <Toolbar :handle-submit="onSendForm" :handle-reset="resetForm">
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-tools</v-icon>{{$t('toolhead.toolheads')}}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <ToolHeadForm ref="createForm" :values="item" :errors="violations" />
    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { createHelpers } from 'vuex-map-fields';
import ToolHeadForm from '../../components/toolhead/Form';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import CreateMixin from '../../mixins/CreateMixin';

const servicePrefix = 'ToolHead';

const { mapFields } = createHelpers({
  getterType: 'toolhead/getField',
  mutationType: 'toolhead/updateField'
});

export default {
  name: 'ToolHeadCreate',
  servicePrefix,
  mixins: [CreateMixin],
  components: {
    Loading,
    Toolbar,
    ToolHeadForm
  },
  data() {
    return {
      item: {}
    };
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations'])
  },
  methods: {
    ...mapActions('toolhead', ['create', 'reset'])
  }
};
</script>
